import $ from 'jquery';
import uniform from 'jquery-uniform';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

/**
 * initPrettyForms
 * Initial Uniform for file uploads and wrap all non-multiselect <select> elements in a container to allow for better styling
 *
 * @ref: https://github.com/steelx/easyListSplitter
 */
function initPrettyForms(e) {
	// Run unform on upload elements only.
	if ($('[type="file"]').length) {
		$('[type="file"]').each(function() {
			const $this = $(this);

			//! if .uploader is not the parent, add it.
			if (!$this.parent().hasClass('uploader')) {
				const classes = $(this).attr('class');
				$this.uniform();

				$this.removeClass(classes).parents('.uploader').addClass(classes);
			}
		});

	}

	// Wrap <div> with the class 'selector' around all <select> elements that do not have the 'multiple' attribute
	if ($('select').length) {
		$('select').not('[multiple="multiple"]').each(function() {
			const $this = $(this);

			//! if .selector is not the parent, add it.
			if (!$this.parent().hasClass('selector')) {
				const classes = $(this).attr('class');

				$this.wrapAll('<div class="selector">');
				$this.removeClass(classes).parents('.selector').addClass(classes);
			}
		});
	}

	// Fixes issue on Windows Chrome where 'ginput_container_fileupload' class is not being appended
	$('input[type="file"]').each(function() {
		$(this).closest('.ginput_container').addClass('ginput_container_fileupload');
	});
};

document.addEventListener('DOMContentLoaded', (e) => {
	if(!$('body').hasClass('woocommerce-checkout')) {
		initPrettyForms(e);
	}
});

$(document).on('gform_post_render', initPrettyForms);
